import { createEditor, type EditorInstance, type EditorOptions } from "@quire/editor";

export type { EditorCommand, EditorInstance, EditorOptions } from "@quire/editor";

/** One way of writing, as the app lists it. */
export interface EditorDefinition {
  id: string;
  label: string;
  /** May return a promise: the editor loads its code on first use. */
  create(container: HTMLElement, options: EditorOptions): EditorInstance | Promise<EditorInstance>;
}

export const editors: EditorDefinition[] = [
  {
    id: "lexical-live",
    label: "Live Markdown",
    create: (container, options) => createEditor(container, { ...options, mode: "live" }),
  },
  {
    id: "rich",
    label: "Rich text",
    create: (container, options) => createEditor(container, { ...options, mode: "rich" }),
  },
  {
    id: "plain",
    label: "Plain text",
    create: (container, options) => createEditor(container, { ...options, mode: "plain" }),
  },
];

export function getEditor(id: string | null | undefined): EditorDefinition {
  return editors.find((e) => e.id === id) ?? editors[0]!;
}
